import { ref, type Ref } from 'vue'
import { defineStore } from 'pinia'
import { useSyncStore } from './sync'
import { type Container } from '@/models/Container'
import type { ContainerType } from '@/models/ContainerType'
import type { Room } from '@/models/Room'
import { ActionType } from '@/actions/Action'

export const useContainerStore = defineStore(
  'containers',
  () => {
    const containers: Ref<Container[]> = ref([])
    const getData = () => containers.value
    const setData = (data: Container[]) => (containers.value = data)

    const findByCode = (code: string) => {
      return containers.value.find((container) => container.code === code) || null
    }

    const findByUuid = (uuid: string) => {
      return containers.value.find((container) => container.uuid === uuid) || null
    }

    const addContainer = async (code: string, type: ContainerType, room: Room) => {
      const syncStore = useSyncStore()
      await syncStore.syncAction({
        type: ActionType.NewContainer,
        payload: {
          code: code,
          typeUuid: type.uuid,
          roomUuid: room.uuid,
        },
      })

      return findByCode(code)
    }

    return {
      containers,
      getData,
      setData,
      findByCode,
      findByUuid,
      addContainer,
    }
  },
  {
    persist: true,
  },
)
